import React, { useEffect } from "react"
import { Layout } from "antd"
import { useSelector } from "react-redux"

import Logo from "../assets/icons/Logo"
import "./style.scss"

const { Header, Content } = Layout

const DefaultLayout = props => {
	const common = useSelector(state => state.common)

	useEffect(() => {}, [common.selectedBg])

	return (
		<div className="welcome-bg" style={{ backgroundImage: `url(${common.selectedBg})` }}>
			<Layout className="default-layout">
				<Header className="header">
					<div className="header__logo">
						<Logo />
					</div>
				</Header>
				<Content className="content">{props.children}</Content>
			</Layout>
		</div>
	)
}

export default DefaultLayout
